import { ReportUploadPanel } from "@/components/report_upload_panel"

interface DotFoodsUploadSectionProps {
  integrationId: string
  onUploaded: () => void
}

/** Upload the Dot Foods Invoice Detail report; queues a `sync-dot-foods` job. */
export function DotFoodsUploadSection({ integrationId, onUploaded }: DotFoodsUploadSectionProps) {
  return (
    <ReportUploadPanel
      endpoint="/api/admin/dotfoods/upload"
      fields={{ integration_id: integrationId }}
      accept={{
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
        "text/csv": [".csv"],
      }}
      dropLabel="Drag and drop the Invoice Detail report"
      formatsLabel=".xlsx (preferred) or .csv"
      successMessage={() => ({
        title: "Upload received",
        description: "Your Dot Foods invoices and deductions will sync in the background.",
      })}
      onUploaded={onUploaded}>
      <div class="rounded-md border border-blue-200 bg-blue-50 p-3 text-sm text-blue-900 space-y-2">
        <p>Export the Invoice Detail report from the Dot Foods supplier dashboard:</p>
        <ol class="list-decimal list-outside space-y-1 ml-5">
          <li>
            Log in at{" "}
            <a
              href="https://dashboard.dotfoods.com/#/"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-blue-700">
              dashboard.dotfoods.com
            </a>{" "}
            and click <strong>Reporting</strong>.
          </li>
          <li>
            Choose <strong>Invoice Detail</strong> as the report type and pick a time period. For your first upload, use
            one day short of a full year.
          </li>
          <li>
            Click <strong>Select all</strong> for State/Province, Customer Number, Ship To, and Product Lines.
          </li>
          <li>
            Click <strong>Run Report</strong>, then <strong>Process Download</strong>.
          </li>
          <li>
            After a few minutes, refresh the page. The file appears under <strong>Your Requested Files</strong>.
          </li>
        </ol>
      </div>
    </ReportUploadPanel>
  )
}
